const isProduction = (): boolean => {
  return process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV === 'production' : false;
}

export default isProduction;
